export function StaticInclude() {
  'ngInject';

  return {
    restrict: 'AE',
    templateUrl: (elem, attrs) => {
      return attrs.src;
    }
  };
}
